import { IS_DEMO_MODE } from '@/config/config'

// Shown above the final buttons of the entry flow: the demo saves nothing.
export const DemoNotSavedNotice = () => {
    if (!IS_DEMO_MODE) return null
    return (
        <p className="mb-4 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
            Démo : rien n'est enregistré.
        </p>
    )
}
